import React, { useState } from 'react';
import './SubscribeModal.css';

const SubscribeModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSubmitting(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email, name })
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Subscription failed');
            }

            setSubmitting(false);
            setSuccess(true);
            setSuccessMessage(data.message); // <-- ADD THIS LINE
            
            // Auto-close after 5 seconds
            setTimeout(() => {
                onClose();
                setEmail('');
                setName('');
                setSuccess(false);
                setSuccessMessage(''); // <-- ADD THIS LINE
            }, 5000);

        } catch (err) {
            console.error('Subscribe error:', err);
            setError(err.message || 'Failed to subscribe. Please try again.');
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        setEmail('');
        setName('');
        setSuccess(false);
        setSuccessMessage(''); // <-- ADD THIS LINE
        setError('');
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content subscribe-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Get Monthly Disc Updates</h2>
                    <button className="close-button" onClick={handleClose}>&times;</button>
                </div>

                {success ? (
                    <div className="subscribe-success">
                        <div className="success-icon">✓</div>
                        <h3>{successMessage || "You're Subscribed!"}</h3>
                        {!successMessage?.includes('already') && !successMessage?.includes('reactivated') && (
                            <p>You'll receive your first update at the end of this month.</p>
                        )}
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="subscribe-form">
                        <p className="subscribe-description">
                            Get a monthly email showing where Jeffrey Discs have traveled and the 
                            memories people have shared. We'll also send infrequent emails about Jeffrey 
                            Discs (such as memorial rounds we'll play). Unsubscribe anytime.
                        </p>

                        <div className="form-group">
                            <label htmlFor="email">Email Address *</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="your@email.com"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="name">Name (optional)</label>
                            <input
                                type="text"
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Your name"
                            />
                        </div>

                        <div className="consent-checkbox">
                            <label>
                                <input type="checkbox" required />
                                I want to receive monthly updates about Jeffrey Discs journeys
                            </label>
                        </div>

                        {error && <div className="error-message">{error}</div>}

                        <div className="modal-actions">
                            <button type="button" className="cancel-button" onClick={handleClose}>
                                Cancel
                            </button>
                            <button 
                                type="submit" 
                                className="submit-button"
                                disabled={submitting}
                            >
                                {submitting ? 'Subscribing...' : 'Subscribe'}
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default SubscribeModal;